import { ExpeditionRightMenuStructure } from "../store";
import { EXPEDITION_RIGHT_MENU } from '../actions-constants/expeditionRightMenu.constants'
const initialExpeditionRightMenu: ExpeditionRightMenuStructure = new ExpeditionRightMenuStructure



export function expeditionRightMenuReducer(expeditionRightMenu: ExpeditionRightMenuStructure = initialExpeditionRightMenu, action): ExpeditionRightMenuStructure {

    switch (action.type) {
        case EXPEDITION_RIGHT_MENU.SET_STATE_MENU:
            return {
                ...expeditionRightMenu,
                stateMenu: action.stateMenu
            }

        case EXPEDITION_RIGHT_MENU.SET_ID_MENU_SELECTION:
            return {
                ...expeditionRightMenu,
                idMenuSelections: action.idMenuSelections
            }


        case EXPEDITION_RIGHT_MENU.SET_SITUATIONS:
            return {
                ...expeditionRightMenu,
                situations: action.situations
            }

        case EXPEDITION_RIGHT_MENU.SET_INITIAL_DATE:
            return {
                ...expeditionRightMenu,
                initialDate: action.initialDate
            }

        case EXPEDITION_RIGHT_MENU.SET_FINAL_DATE:
            return {
                ...expeditionRightMenu,
                finalDate: action.finalDate
            }

        case EXPEDITION_RIGHT_MENU.SET_ORDENATE_FILTER:
            return {
                ...expeditionRightMenu,
                ordernateFilter: action.ordernateFilter
            }


        default:
            return expeditionRightMenu
    }
}